/**
  * Open Modal javscript trigger
  *
  * */
function openModal(modal, opener){
  if(modal && opener != undefined) modal.show(opener);
}

function updateCartCountInHeader(){
  const desktopCartCount = document.querySelector(`#cart-icon-desktop .cart-count`);
  const mobileCartCount = document.querySelector(`#cart-icon-mobile .cart-count`);

  if (desktopCartCount) {
    desktopCartCount.innerHTML = window.globalSpace.cart.item_count;
    desktopCartCount?.classList.toggle('d-none', window.globalSpace.cart.item_count === 0);
  }
  if (mobileCartCount) {
    mobileCartCount.innerHTML = window.globalSpace.cart.item_count;
    mobileCartCount?.classList.toggle('d-none', window.globalSpace.cart.item_count === 0);
  }
}

/**
  * Dropdown component Events and Methods
  *
  * @param {element} element - Dropdown element
  */
 class Dropdown {
  constructor(element) {
    this.dropdown = element;
    this.toggleCTA = element.querySelector('.dropdown-toggle');
    this.supportedEvents = ["click", "touchend", "focusout"];

    this.init();
  }

  init() {
    this.supportedEvents.forEach((type) => {
      if (type === 'click' || type === 'touchend') {
        this.toggleCTA.addEventListener(type, (evt) => {
          const href = this.toggleCTA.getAttribute('href');
          const isDesktop = window.innerWidth >= 1200;
          if (isDesktop && this.toggleCTA.tagName === 'A' && href && href !== '#' && href !== window.location.href && !this.dropdown.classList.contains('force-dropdown')) {
            // Let browser navigate (desktop only)
            return;
          }
          evt.preventDefault();
          this.toggleDropdown();
        });
      } else if(type == 'focusout'){
        this.dropdown.addEventListener(type, (evt) => {
          if (!this.dropdown.contains(evt.relatedTarget) && this.dropdown.classList.contains('open')) {
            this.dropdownHide(this.dropdown);
          }
        });
      }
    });

    // Add click outside listener
    document.addEventListener('click', this.handleClickOutside.bind(this));

    this.bindEvents();
  }

  handleClickOutside(event) {
    if (this.dropdown.classList.contains('open') && !this.dropdown.contains(event.target)) {
      this.dropdownHide(this.dropdown);
    }
  }

  bindEvents(){
    const closeBtn = this.dropdown.querySelector('.slideout-submenu');
    if (closeBtn) {
      closeBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.dropdownToggle(this.dropdown);
      });
    }
  }

  toggleDropdown() {
    this.dropdownToggle(this.dropdown);
  }

  dropdownToggle(dropdownParent) {
    setTimeout(() => {
      dropdownParent.classList.contains('open')
        ? this.dropdownHide(dropdownParent)
        : this.dropdownShow(dropdownParent);
    }, 50);
  }

  dropdownShow(dropdownParent) {
    if (!dropdownParent) {
      return;
    }
    this.toggleCTA.setAttribute('aria-expanded', true);
    dropdownParent.classList.add('open');
  }

  dropdownHide(dropdownParent) {
    if (!dropdownParent) return;

    this.toggleCTA.setAttribute('aria-expanded', false);
    dropdownParent.classList.remove('open');

    const childDropdowns = dropdownParent.querySelectorAll('.dropdown.open');
    if (childDropdowns.length > 0) {
      childDropdowns.forEach((child) => {
        child.classList.remove('open');
        child.querySelector('.dropdown-toggle').setAttribute('aria-expanded', false);
      });
    }
  }

  childOnFocusChange(dropdownParent) {
    const openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    const currentIndex = openDropdowns.indexOf(dropdownParent);
    openDropdowns.forEach((ele) => {
      const eleIndex = openDropdowns.indexOf(ele);
      if (eleIndex !== currentIndex) {
        this.dropdownHide(ele);
      }
    });
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleClickOutside.bind(this));
  }
}
const allDropdowns = document.querySelectorAll('[is="drop-down"]');
allDropdowns.forEach((ele) => {
  new Dropdown(ele);
});

/**
* background Overlay
*/
class SiteOverlay extends HTMLElement{
  constructor() {
    super();
    this.overlayElement = document.querySelector('#site-overlay');
    this.bindEvents();
  }
  
  // Static cache for frequently accessed elements
  static _overlayCache = null;
  static _bodyCache = null;
  
  /**
   * Get cached overlay element
   * @returns {HTMLElement|null}
   */
  static get overlayElement() {
    if (!this._overlayCache) {
      this._overlayCache = document.querySelector('#site-overlay');
    }
    return this._overlayCache;
  }
  
  /**
   * Get cached body element
   * @returns {HTMLElement}
   */
  static get bodyElement() {
    if (!this._bodyCache) {
      this._bodyCache = document.body;
    }
    return this._bodyCache;
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   */
  onClick(){
    // Don't allow closing if location is required (no zipcode set)
    if (window.locationManager && !window.locationManager.isIdentified()) {
      return; // Block overlay click when location is mandatory
    }
    
    const closeSearch = document.querySelector('search-modal')?.classList.contains("open__modal");
    if(closeSearch) document.querySelector('.search-modal__close-button')?.dispatchEvent(new Event('click'));
  
    SiteOverlay.hideOverlay();
  }

  /**
   * Show Overlay - Production optimized with scroll position preservation
   * @returns {void}
   */
   static showOverlay(){
    try {
      // Use cached DOM elements for better performance
      const overlay = this.overlayElement;
      const body = this.bodyElement;
      
      if (!overlay || !body) return;
      
      // Get current scroll position with cross-browser support
      const scrollTop = window.pageYOffset || 
                       document.documentElement.scrollTop || 
                       body.scrollTop || 
                       0;
      
      // Only proceed if not already showing overlay
      if (!body.classList.contains('scroll-fixed')) {
        // Store scroll position as data attribute (more reliable than CSS variables)
        body.dataset.scrollPosition = scrollTop;
        
        // Set CSS variable for visual positioning during fixed state
        body.style.setProperty('--scroll-position', `-${scrollTop}px`);
        
        // Apply overlay and fixed positioning
        overlay.classList.add('overlay--body');
        overlay.setAttribute('aria-hidden', 'false');
        body.classList.add('scroll-fixed');
      }
    } catch (error) {
      console.warn('SiteOverlay.showOverlay error:', error);
    }
  }

  /**
   * Hide overlay - Production optimized with smooth scroll restoration
   * @returns {void}
   */
  static hideOverlay(){
    try {
      // Close any open drawers first
      const openDrawers = document.querySelectorAll('custom-drawer.open');
      openDrawers.forEach(drawer => {
        if (drawer && typeof drawer.closeDrawer === 'function') {
          drawer.closeDrawer();
        }
      });
      
      // Use cached DOM elements
      const overlay = this.overlayElement;
      const body = this.bodyElement;
      
      if (!overlay || !body) return;
      
      // Remove overlay
      overlay.classList.remove('overlay--body');
      overlay.setAttribute('aria-hidden', 'true');
      
      // Only restore if we have a stored position
      const storedPosition = body.dataset.scrollPosition;
      
      if (storedPosition !== undefined && body.classList.contains('scroll-fixed')) {
        // Parse stored position with fallback
        const scrollValue = parseInt(storedPosition, 10) || 0;
        
        // Remove fixed positioning
        body.classList.remove('scroll-fixed');
        
        // Restore scroll position using the most compatible method
        // Use immediate restoration to prevent visual jumps
        if ('scrollBehavior' in document.documentElement.style) {
          // Modern browsers with scrollBehavior support
          window.scrollTo({
            top: scrollValue,
            left: 0,
            behavior: 'instant'
          });
        } else {
          // Fallback for older browsers
          window.scrollTo(0, scrollValue);
        }
        
        // Clean up data attributes and CSS variables
        delete body.dataset.scrollPosition;
        body.style.removeProperty('--scroll-position');
      } else {
        // Just remove the class if no position was stored
        body.classList.remove('scroll-fixed');
      }
    } catch (error) {
      console.warn('SiteOverlay.hideOverlay error:', error);
      // Ensure we at least remove the fixed class on error
      document.body.classList.remove('scroll-fixed');
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick.bind(this));
    this.removeEventListener('touchend', this.onClick.bind(this));
  }
}
customElements.define("site-overlay", SiteOverlay, {
  once: true
});

/**
* Custom Video
*/
class CustomVideo extends HTMLElement {
  constructor() {
    super();

    this.type = this.getAttribute('data-video-type');
    this.videoURL = this.getAttribute('data-video-id');
    this.placementType = this.getAttribute('data-placement');
    this.videoStatus = 'empty';

    this.container = this.closest('.custom-video-container');
    this.videoModal = document.getElementById('PopupModal-video');
    this.contentSection = this.querySelector('.content-section');
    this.videoSection = this.querySelector('.video-section');
    if(this.placementType == 'popup') this.videoSection = this.videoModal.querySelector('.video-container');
    this.triggerVideo = this.querySelector('[data-trigger-video]') || this.container.querySelector('[data-trigger-video]');

  }

  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    if (this.triggerVideo) {
      this.triggerVideo.removeEventListener('click', this.toggleView.bind(this));
    }
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    if(this.querySelector('[data-poster-video]')) this.managePosterVideos();
    if(this.triggerVideo) this.triggerVideo.addEventListener('click', this.toggleView.bind(this));
    if(this.dataset.placement == 'grid' && this.dataset.autoplay == 'true' && !this.closest('swiper-slide')) this.autoplayOnInit();
    // if(this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(_event){
    if(this.container.classList.contains('playing--video')) this.toggleView();
  }

  /**
   * Toggle of video modal
   */
  toggleView(event){
    if(event) event.preventDefault();
    const isOpen = this.container.classList.contains('playing--video');
    if (isOpen) {
      this.hideContent();
    } else {
      this.showContent();
    }
  }

  /**
   * Show panel content
   */
  showContent() {
    if (this.videoStatus === 'empty' || this.placementType === 'popup') {
      const videoElement = this._buildVideo();
      videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);
      this.videoSection.appendChild(videoElement);
      this.videoStatus = 'loaded';

      setTimeout(() => {
        (this.placementType === 'popup') ? openModal(this.videoModal, this.triggerVideo) : this.container.classList.add('playing--video');
        this.videoSection.setAttribute('aria-hidden', 'false');
        if(this.dataset.controls == 'true') this.pauseOnVisibilityChange(videoElement);
      }, 500);
    } else {
      const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
      this.container.classList.add('playing--video');
      this._playVideo(videoElement);
    }
  }

  /**
   * Hide panel content
   */
  hideContent() {
    this.container.classList.remove('playing--video');
    this.videoSection.setAttribute('aria-hidden', 'true');
    const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
    if (videoElement) {
      this._pauseVideo(videoElement);
    }
  }

  _playVideo(video){
    if(this.type == 'local'){
      video.play();
    }else if(this.type == 'youtube'){
      video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }
  }

  _pauseVideo(video) {
    if (this.type === 'local') {
      video.pause();
    } else if (this.type === 'youtube') {
      video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }
  }

  /**
   * 
   * Create the video html element
   */
  _buildVideo(){
    let video;

    if(this.type == 'local'){
      video = document.createElement('video');
      video.src = this.videoURL;
      if(this.dataset.controls == 'true') video.controls = this.dataset.controls;
      if(this.dataset.muted == 'true') video.muted = this.dataset.muted;
      video.autoplay = true;
      if(this.dataset.loop == 'true') video.loop = this.dataset.loop;
      video.playsInline = true;
    }else if(this.type == 'youtube'){
      const videoID = this.videoURL.replace('https://www.youtube.com/watch?v=', '');
      video = document.createElement( "iframe" );
      video.setAttribute( "allowfullscreen", "" );
      video.setAttribute( "frameborder", "0" );
      video.setAttribute( "allow", "autoplay");
      video.setAttribute( "src", `https://www.youtube.com/embed/${videoID}?rel=0&showinfo=0&autoplay=1&mute=${this.dataset.muted == 'true' ? 1 : 0}&controls=${this.dataset.controls == 'true' ? 1 : 0}&loop=${this.dataset.loop == 'true' ? 1 : 0}&enablejsapi=1&origin=${window.origin}` );
      // &playlist=${videoID}
    }
    return video;
  }

  /**
   * Pause video on scroll when out of viewport
   *
  */
  pauseOnVisibilityChange(videoEle){
    this.scrollObserver = new IntersectionObserver((entries) => { 
      if(videoEle == undefined || videoEle.contentWindow == null){
        this.scrollObserver.disconnect();
        return;
      }

      if(!entries[0].isIntersecting){
        this._pauseVideo(videoEle)
      }
    });
    this.scrollObserver.observe(videoEle);
  }

  /**
   * Poster Video Autoplay
   *
  */
  managePosterVideos(){
    const posterVideo = this.querySelector('[data-poster-video]');
    if(!posterVideo) return;

    const videoIntersection = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.target) {
          const sourceTag = document.createElement('source');
          sourceTag.src = entry.target.dataset.src;
          sourceTag.type = "video/mp4";
          entry.target.appendChild(sourceTag)
          entry.target.play();
          observerPosterVideo.disconnect();
        }
      }
    };
    const observerPosterVideo = new IntersectionObserver(videoIntersection);
    observerPosterVideo.observe(posterVideo);
  }

  autoplayOnInit(element = this){
    const elementIntersection = (entries) => {
      if(entries[0].isIntersecting && entries[0].intersectionRatio > 0){
        element.toggleView();
        observeElement.disconnect();
      }
    };
    let observeElement = new IntersectionObserver(elementIntersection);
    observeElement.observe(element);
  }
}
customElements.define("custom-video", CustomVideo);

/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector('.modal');
    this.modalOpeners = [...document.querySelectorAll(`[data-modal-opener="${this.id}"]`)];
    this.closeBtn = this.querySelector('[id^="ModalClose-"]');
  }

  connectedCallback() {
    this.modalOpeners.forEach((opener)=>{
      opener.addEventListener('click', (evt)=>{
    
        evt.preventDefault();
        this.show(opener);
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.hide.bind(this));
    }

    this.addEventListener('click', (evt) => {
      // Close when clicking outside the modal content (on the backdrop)
      const modalContent = this.querySelector('.modal-content');
      if (modalContent && !modalContent.contains(evt.target)) {
        this.hide();
      }
    });

    this.addEventListener('keyup', (evt) => {
      if (evt.code && evt.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  // Clean up event listeners
  disconnectedCallback() {
    this.modalOpeners.forEach((opener) => {
      opener.removeEventListener('click', this.show.bind(this));
    });

    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }

    this.removeEventListener('click', this.hide);
    this.removeEventListener('keyup', this.hide);
  }

  /**
   * Open the Modal
   * @param {element} opener 
   */
  show(opener) {
    this.openedBy = opener;
    this.modal.classList.add('open');
    this.setAttribute('aria-hidden', false);

    SiteOverlay.showOverlay();
    Utility.trapFocus(this);
    Utility.forceFocus(this.closeBtn);
  }

  /**
   * Close Modal Dialogue
   */
  hide() {
    this.modal.classList.remove('open');
    this.setAttribute('aria-hidden', true);

    SiteOverlay.hideOverlay();
    Utility.removeTrapFocus(this.openedBy);
    if(this.id == 'PopupModal-video') this.querySelector('.video-container').innerHTML = '';
  }
}
customElements.define('modal-dialog', ModalDialog);

/**
   * Manage Custom Notification Trigger
   *
   */
class ToastNotification extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.snotifyToast');
    this.closeBtn = this.querySelector('.snotifyToast__close');
    this.animateNotifcation = null;

    // Set ARIA role for accessibility
    this.container.setAttribute('role', 'alert');
  }

  connectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();
      });
    }
  }

  disconnectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }
  }

  /**
   * Notification Type
   * @param {string} title 
   * @param {string} body 
   * @param {object} options 
   */
  updateNotification(title, body, options){
    this.querySelector('.snotifyToast__title').textContent = title;
    this.querySelector('.snotifyToast__body').textContent = body;

    this.container.classList.remove('d-none');
    this.container.classList.add('open', `snotify-${options.type}`);
    this._manageToggle(options.timeout);
  }

  /**
   * Duration of notification to hide again
   * @param timeout 
   */
  _manageToggle(timeout) {
    this.progressBar = this.querySelector('[data-toast-pr]');
    const totalFrames = Math.ceil(timeout / 16.67) / 2;
    let frame =0; 
    let width = 0;

    this.animateNotifcation = () => {
      width = (frame / totalFrames) * 100;
      this.progressBar.setAttribute('style', `width: ${width}%`);
      if (frame < totalFrames) {
        frame++;
        requestAnimationFrame(this.animateNotifcation);
      } else {
        this.closeBtn.dispatchEvent(new Event('click'));
      }
    };
    requestAnimationFrame(this.animateNotifcation);
  }

  hide() {
    if (this.animateNotification) {
      cancelAnimationFrame(this.animateNotification);
    }
    this.container.className = 'snotifyToast d-none';
    [this.querySelector('.snotifyToast__title'),this.querySelector('.snotifyToast__body')].forEach(ele => ele.textContent = '');
    this.querySelector("[data-toast-pr]").removeAttribute("style");
  }
}
customElements.define("toast-notification", ToastNotification);
// Don't set notificationEle here - it will be null if DOM isn't ready
// Instead, we'll get it when needed or set it in DOMContentLoaded

class CustomDrawer extends HTMLElement {
  constructor() {
      super();
      this.isOpen = false;

      this.openedBy = null;
      this.toggleDrawer = document.querySelectorAll(`[data-toggleDrawer="${this.id}"], a[href="#${this.id}"]`);
      this.closeButtons = this.querySelectorAll('[data-closedrawer]');
      this.forceFocus = this.querySelector('.drawer-header') || this.querySelector('.first-focusable-ele')
  }

  connectedCallback() {
    this.bindEvents()
  }

  disconnectedCallback() {
    this.toggleDrawer.forEach(btn => btn.removeEventListener('click', this.openDrawer()));

    this.closeButtons.forEach(btn => btn.removeEventListener('click', this.closeDrawer.bind(this)));
    this.removeEventListener('keyup', this.onKeyUp.bind(this));
    this.removeEventListener('focusout', this.focusOut.bind(this));
  }

  bindEvents(){
    this.toggleDrawer.forEach(btn => {
      btn.setAttribute('aria-expanded', false);
      btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        (this.isOpen) ? this.closeDrawer(evt) : this.openDrawer(evt.currentTarget);
      });
    });

    this.closeButtons.forEach(btn => btn.addEventListener('click', this.closeDrawer.bind(this)));
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Escape Key Press to close drawer when focus is within the container
   */
  onKeyUp(event) {
    if(event.code == undefined || event.code && event.code.toUpperCase() !== 'ESCAPE') return;
    this.closeDrawer();
  }

  /**
   * Focus Out Event to close drawer
   */
  focusOut(evt){
    if (!this.contains(evt.relatedTarget) && this.open) {
      this.closeDrawer();
    }
  }

  openDrawer(opener) {
    this.resetOtherDrawers();

    this.isOpen = true;
    this.openedBy = opener || null;
    this.classList.add('open');
    this.setAttribute('aria-hidden', 'false');
    this.openedBy?.setAttribute('aria-expanded', true);

    SiteOverlay.showOverlay();
    
    // Add search-overlay class to site-overlay when search modal is opened
    if (this.id === 'header-search-layer') {
      getHeaderHeight();
      document.querySelector('#site-overlay')?.classList.add('search-overlay');
      
      // Set dynamic top position based on visible header height
      const visibleHeight = getVisibleHeaderHeight();
      this.style.setProperty('--search-modal-top', visibleHeight + 'px');
    }
    
    Utility.trapFocus(this, this.forceFocus);
    Utility.forceFocus(this.forceFocus);
  }

  closeDrawer() {
      this.isOpen = false;
      this.classList.remove('open');
      this.setAttribute('aria-hidden', 'true');
      this.openedBy?.setAttribute('aria-expanded', false);
      
      // Remove search-overlay class from site-overlay when search modal is closed
      if (this.id === 'header-search-layer') {
        document.querySelector('#site-overlay')?.classList.remove('search-overlay');
      }
      
      SiteOverlay.hideOverlay();
      Utility.removeTrapFocus(this.openedBy);
      this.openedBy = null;

      // Close all open dropdowns/panels when drawer is closed
      this.hideOpenPanels();

      if(this.id == 'quickshop-drawer') this.querySelector('[data-quickshop-body]').innerHTML = '';
  }

  resetOtherDrawers(){
    const openDrawers = document.querySelectorAll('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
  }

  hideOpenPanels(){
    let openPanels = this.querySelectorAll('[is="collapsiblePanel"].open');
    openPanels.forEach(panel => panel.querySelector('[data-toggle="panel"]').click());

    let openDropdowns = Array.from(this.querySelectorAll('[is="drop-down"].open'));
    openDropdowns.forEach((ele) => {
      ele.classList.remove('open');
      ele.querySelector('[data-toggle="open"]')?.setAttribute('aria-expanded', false);
    });
  }
}
customElements.define('custom-drawer', CustomDrawer);

const swiperSliders = document.querySelectorAll('swiper-container');
swiperSliders.forEach(swiperEle => {
  swiperEle.addEventListener('swiperslidechange', (event) => {
    const index = event.detail[0].activeIndex;
    const swipDirection = event.detail[0].swipeDirection;
    const prevSlide = swiperEle.querySelector(`swiper-slide[data-index="${swipDirection == 'prev' ? index+2 : index}"]`);
    const activeSlide = swiperEle.querySelector(`swiper-slide[data-index="${index+1}"]`);

    // Pause previous slide video if available
    if(prevSlide && prevSlide.querySelector('.custom-video-container.playing--video')){
      let customElement = prevSlide.querySelector('custom-video');
      let videoEle = customElement.querySelector('video') || customElement.querySelector('iframe');
      if(videoEle && customElement.dataset.controls == 'true') {
        customElement._pauseVideo(videoEle);
      }
    }

    // Play active slide video if available
    if(prevSlide && activeSlide.querySelector('.custom-video-container')){
      let customElement = activeSlide.querySelector('custom-video');
      if(customElement.videoStatus == 'empty'){
        customElement.toggleView();
      }else{
        let videoEle = customElement.querySelector('video') || customElement.querySelector('iframe');
        if(videoEle) customElement._playVideo(videoEle);
      }
    }
  });
});

// Global function to get and set header heights
const getHeaderHeight = () => {
  const totalHeight = (document.querySelector('[data-top-bar]')?.offsetHeight || 0) + (document.querySelector('.site-header')?.offsetHeight || 0);
  document.documentElement.style.setProperty('--total-header-height', totalHeight + 'px');
};

// Dynamic function to get visible header height (excludes topbar when scrolled)
const getVisibleHeaderHeight = () => {
  const topbar = document.querySelector('[data-top-bar]');
  const header = document.querySelector('.site-header');
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
  let visibleHeight = header?.offsetHeight || 0;
  
  // Only include topbar height if it's still visible (not scrolled past)
  if (topbar && scrollTop < (topbar.offsetHeight || 0)) {
    visibleHeight += topbar.offsetHeight;
  }
  
  return visibleHeight;
};

// Search Modal javascript
document.addEventListener('DOMContentLoaded', function() {
    // Check and hide/show specifications tab on initial load
    const initSpecsTabVisibility = () => {
        const specsTab = document.querySelector('[data-specs-tab]');
        const specsPanel = document.querySelector('[data-specs-panel]');
        const specsList = document.querySelector('[data-variant-specs-list]');
        const specsImage = document.querySelector('[data-variant-specs-image]');
        
        if (specsTab && specsPanel) {
            const hasSpecsContent = specsList && specsList.innerText.trim() !== '';
            const hasSpecsImage = specsImage && specsImage.innerHTML.trim() !== '';
            
            if (!hasSpecsContent && !hasSpecsImage) {
                // Hide the specifications tab if no content
                specsTab.style.display = 'none';
                specsPanel.style.display = 'none';
                
                // If specs tab is active, switch to first tab
                if (specsTab.classList.contains('active')) {
                    specsTab.classList.remove('active');
                    specsTab.setAttribute('aria-selected', 'false');
                    specsTab.setAttribute('aria-expanded', 'false');
                    specsPanel.classList.remove('open');
                    specsPanel.setAttribute('aria-hidden', 'true');
                    
                    // Activate first visible tab
                    const firstTab = document.querySelector('.tablink:not([style*="display: none"])');
                    if (firstTab) {
                        firstTab.classList.add('active');
                        firstTab.setAttribute('aria-selected', 'true');
                        firstTab.setAttribute('aria-expanded', 'true');
                        
                        const targetPanelId = firstTab.getAttribute('data-target');
                        const targetPanel = document.querySelector(targetPanelId);
                        if (targetPanel) {
                            targetPanel.classList.add('open');
                            targetPanel.setAttribute('aria-hidden', 'false');
                        }
                    }
                }
            }
        }
    };
    
    // Run on load
    initSpecsTabVisibility();
    
  getHeaderHeight();
  window.addEventListener('resize', () => setTimeout(getHeaderHeight, 100));
  
  // Update search modal position on scroll if it's open
  let scrollTimeout;
  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      const searchModal = document.querySelector('#header-search-layer');
      if (searchModal && searchModal.classList.contains('open')) {
        const visibleHeight = getVisibleHeaderHeight();
        searchModal.style.setProperty('--search-modal-top', visibleHeight + 'px');
      }
    }, 10);
  });
});

/**
 * Zone Price Manager - Handles switching between Zone 1 and Zone 2 prices
 */
class ZonePriceManager {
  constructor() {
    // Load saved zone or default to Zone 2
    const savedZone = localStorage.getItem('userZone');
    this.currentZone = (savedZone && (savedZone === '1' || savedZone === '2')) ? parseInt(savedZone) : 2;
    this.init();
  }

  init() {
    // Set initial zone display
    this.showZone(this.currentZone);
    
    // Make globally accessible
    window.zonePriceManager = this;
  }

  /**
   * Switch to specific zone
   * @param {number} zone - Zone number (1 or 2)
   */
  showZone(zone) {
    this.currentZone = zone;
    
    if (zone === 1) {
      // Show Zone 1, Hide Zone 2
      this.toggleElements('[zone-1-element]', true);
      this.toggleElements('[zone-2-element]', false);
    } else if (zone === 2) {
      // Show Zone 2, Hide Zone 1
      this.toggleElements('[zone-1-element]', false);
      this.toggleElements('[zone-2-element]', true);
    }

    // Trigger custom event for other components
    document.dispatchEvent(new CustomEvent('zoneChanged', {
      detail: { zone: zone }
    }));
  }

  /**
   * Toggle visibility of elements
   * @param {string} selector - CSS selector
   * @param {boolean} show - Whether to show or hide
   */
  toggleElements(selector, show) {
    const elements = document.querySelectorAll(selector);
    elements.forEach(element => {
      element.style.display = show ? '' : 'none';
    });
  }

  /**
   * Get current zone
   * @returns {number} Current zone number
   */
  getCurrentZone() {
    return this.currentZone;
  }

  /**
   * Toggle between zones
   */
  toggleZone() {
    const newZone = this.currentZone === 1 ? 2 : 1;
    this.showZone(newZone);
  }
}

// Location Manager - Handles zip code validation and zone assignment
class LocationManager {
  constructor() {
    this.isMobile = window.innerWidth < 1200;
    const savedZip = localStorage.getItem('userZipCode');
    const savedZone = localStorage.getItem('userZone');
    
    // Load saved zipcode (even if zone is missing) else show drawer
    if (savedZip) {
      this.loadZipcode(savedZip, savedZone);
    } else {
      this.showDrawer();
    }
    this.setupListeners();
    // Expose globally for other components (e.g., overlay guards)
    window.locationManager = this;

    // Ensure labels are restored on bfcache restores or when page is shown again
    window.addEventListener('pageshow', () => {
      const zip = localStorage.getItem('userZipCode');
      if (zip) this.setLabels(zip);
    });
  }

  // Apply zipcode to both labels with a short retry in case elements mount late
  setLabels(zipcode) {
    const trySet = () => {
      const desktopEl = document.querySelector('#current-desktop-location');
      const mobileEl = document.querySelector('#current-location-mobile');
      
      if (desktopEl) desktopEl.textContent = zipcode;
      if (mobileEl) mobileEl.textContent = zipcode;
      
      // Return true only if BOTH elements exist
      return Boolean(desktopEl && mobileEl);
    };
    
    // Try immediately
    if (trySet()) return;
    
    // If elements not found, retry with interval
    let attempts = 0;
    const interval = setInterval(() => {
      attempts++;
      if (trySet() || attempts >= 50) {
        clearInterval(interval);
      }
    }, 50);
  }

  loadZipcode(zipcode, zone) {
    // Always update both labels to avoid viewport/responsive race conditions
    this.setLabels(zipcode);
    const parsedZone = parseInt(zone);
    if (window.zonePriceManager && (parsedZone === 1 || parsedZone === 2)) {
      window.zonePriceManager.showZone(parsedZone);
    }
  }

  showDrawer() {
    const primarySelector = this.isMobile ? '[data-mobile-current-location]' : '[data-desktop-current-location]';
    let drawer = document.querySelector(primarySelector);
    // Fallback: if primary not present (markup differences), try the other
    if (!drawer) drawer = document.querySelector(this.isMobile ? '[data-desktop-current-location]' : '[data-mobile-current-location]');
    if (drawer) drawer.classList.add('open');
  }

  setupListeners() {
    document.addEventListener('click', (e) => {
      const target = e.target;
      
      if (target.closest('[desktop-open-location]') || target.closest('[open-location-mobile]')) {
        e.preventDefault();
        const isDesktopTrigger = !!target.closest('[desktop-open-location]');
        const primarySelector = isDesktopTrigger ? '[data-desktop-current-location]' : '[data-mobile-current-location]';
        let drawer = document.querySelector(primarySelector);
        if (!drawer) {
          // Fallback to the other drawer if expected one isn't present in DOM
          drawer = document.querySelector(isDesktopTrigger ? '[data-mobile-current-location]' : '[data-desktop-current-location]');
        }
        if (drawer) drawer.classList.toggle('open');
      }
      
      // Close button for mobile location drawer
      if (target.closest('.location-close-icon')) {
        e.preventDefault();
        const mobileDrawer = document.querySelector('[data-mobile-current-location]');
        if (mobileDrawer) mobileDrawer.classList.remove('open');
      }
      
      if (target.closest('[data-desktop-confirm-location]') || target.closest('[data-mobile-confirm-location]')) {
        e.preventDefault();
        const isMobileConfirm = !!target.closest('[data-mobile-confirm-location]');
        const input = document.querySelector(isMobileConfirm ? '[data-mobile-location-input]' : '[data-desktop-location-input]');
        if (input) this.validate(input.value.trim(), isMobileConfirm ? 'mobile' : 'desktop');
      }
    });
    
    // Enter key submission
    ['[data-desktop-location-input]', '[data-mobile-location-input]'].forEach((selector, i) => {
      const input = document.querySelector(selector);
      input?.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.validate(e.target.value.trim(), i === 1 ? 'mobile' : 'desktop');
        }
      });
    });
  }

  
  async validate(zipcode, device) {
    if (!zipcode || zipcode.length !== 5) {
      this.notify('Invalid Input', 'Please enter a valid 5-digit zip code', 'error');
      return;
    }
    const btn = document.querySelector(`[data-${device}-confirm-location]`);
    if (btn) { btn.disabled = true; btn.textContent = 'Validating...'; }
    
    try {
      const res = await fetch("/apps/zip-code-validator/api/zip-code-zone", {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ zip_code: zipcode })
      });
      
      const data = await res.json();
      
      if (data.statusCode === 200 && data.status) {
        this.onSuccess(zipcode, parseInt(data.data?.tier_zone), device);
      } else {
        this.onError(data.message || 'Invalid zip code. Please try again.', device);
      }
    } catch (err) {
      console.error('Zipcode validation error:', err);
      this.onError('Unable to validate zip code. Please try again.', device);
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = 'Confirm'; }
    }
  }

  onSuccess(zipcode, zone, device) {
    localStorage.setItem('userZipCode', zipcode);
    localStorage.setItem('userZone', zone.toString());
    localStorage.setItem('customZoneSet', 'true');
    
    // Update both labels so it stays consistent across responsive switches
    const drawer = document.querySelector(device === 'mobile' ? '[data-mobile-current-location]' : '[data-desktop-current-location]');
    
    this.setLabels(zipcode);
    if (drawer) drawer.classList.remove('open');
    if (window.zonePriceManager) window.zonePriceManager.showZone(zone);
    
    this.notify('Zipcode Confirmed!', `Your zipcode ${zipcode} has been set successfully. You're in Zone ${zone}.`, 'success');
  }

  onError(message, device) {
    this.notify('Invalid Zipcode', message, 'error');
    const input = document.querySelector(device === 'mobile' ? '[data-mobile-location-input]' : '[data-desktop-location-input]');
    if (input) { input.value = ''; input.focus(); }
  }

  notify(title, message, type) {
    const toast = window.notificationEle || document.querySelector('toast-notification');
    if (toast) toast.updateNotification(title, message, { type, timeout: 4000 });
  }

  // Used by other components to check whether location is set
  isIdentified() {
    const savedZip = localStorage.getItem('userZipCode');
    const savedZone = localStorage.getItem('userZone');
    return Boolean(savedZip && savedZone);
  }
}

// Accessibility: Keyboard navigation for clickable divs with role="button" or role="checkbox"
document.addEventListener('keydown', (e) => {
  if (e.key === 'Enter' || e.key === ' ') {
    const target = e.target;
    const role = target.getAttribute('role');
    
    if (role === 'button' || role === 'checkbox') {
      e.preventDefault();
      target.click();
      
      // Update aria-pressed for buttons
      if (role === 'button' && target.hasAttribute('aria-pressed')) {
        const isPressed = target.getAttribute('aria-pressed') === 'true';
        target.setAttribute('aria-pressed', !isPressed);
      }
      
      // Update aria-checked for checkboxes  
      if (role === 'checkbox' && target.hasAttribute('aria-checked')) {
        const isChecked = target.getAttribute('aria-checked') === 'true';
        target.setAttribute('aria-checked', !isChecked);
      }
    }
  }
});

// Initialize managers
function initializeManagers() {
  window.notificationEle = window.notificationEle || document.querySelector('toast-notification');
  new ZonePriceManager();
  new LocationManager();
}
// Initialize on DOM ready - Handle both cases: DOM already loaded or still loading
if (document.readyState === 'loading') {
  // DOM is still loading, wait for DOMContentLoaded
  document.addEventListener('DOMContentLoaded', initializeManagers);
} else {
  // DOM is already loaded (script loaded late or with async)
  initializeManagers();
}
